"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _IconButton = _interopRequireDefault(require("./IconButton"));
var _sebikostudioIcons = require("sebikostudio-icons");
require("./TopBanner.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TopBanner = function TopBanner(_ref) {
  var username = _ref.username,
    notification = _ref.notification,
    onDismiss = _ref.onDismiss;
  if (!notification) {
    return null;
  }
  var title = notification.title,
    text = notification.text,
    style = notification.style;
  var bannerClass = style ? "TopBanner ".concat(style) : "TopBanner";
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: bannerClass,
    align: "center",
    justify: "between"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: "large",
    weight: "bold"
  }, title), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, text)), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    size: "medium",
    variant: "ghost-static",
    onClick: onDismiss
  }, /*#__PURE__*/_react["default"].createElement(_sebikostudioIcons.Cross1Icon, null)));
};
var _default = exports["default"] = TopBanner;